import { isoDateToDisplay } from '../isoDateDisplay';
import { fileInput, input, label } from './adminUi';
import PublicationDateField from './PublicationDateField';
import RichTextEditor from './RichTextEditor';

export default function ArticleForm({ article, onChange, onUploadImage, uploadHint }) {
  function set(field, value) {
    onChange({ ...article, [field]: value });
  }

  const gridClass = 'grid w-full gap-6 sm:grid-cols-2';

  return (
    <div className={gridClass}>
      <label className={`${label} sm:col-span-2`}>
        Title
        <input className={input} value={article.title} onChange={(e) => set('title', e.target.value)} />
      </label>
      <PublicationDateField
        value={article.dateIso}
        onChange={(v) => {
          onChange({
            ...article,
            dateIso: v,
            date: v ? isoDateToDisplay(v) : '',
          });
        }}
      />
      <div className={`${label} sm:col-span-2`}>
        <span className="block">Excerpt</span>
        <span className="mb-2 mt-0.5 block text-[11px] font-normal text-neutral-500">
          Summary for home cards and the article lead (rich text).
        </span>
        <RichTextEditor
          key={`${article.id}-excerpt`}
          value={article.excerpt ?? ''}
          onChange={(html) => set('excerpt', html)}
          placeholder="Short summary…"
          editorMinHeight="6rem"
        />
      </div>
      <div className={`${label} sm:col-span-2`}>
        <span className="block">Full article</span>
        <span className="mb-2 mt-0.5 block text-[11px] font-normal text-neutral-500">
          Optional — full story on the news detail page (rich text).
        </span>
        <RichTextEditor
          key={`${article.id}-body`}
          value={article.body ?? ''}
          onChange={(html) => set('body', html)}
          placeholder="Write the full article…"
          editorMinHeight="14rem"
        />
      </div>

      <div className="sm:col-span-2 rounded-xl border border-neutral-200/90 bg-neutral-50/80 p-4 sm:p-5">
        <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-neutral-500">Cover image</p>
        <label className={`${label} mb-0`}>
          Upload (Cloudinary)
          <input
            type="file"
            accept="image/*"
            className={fileInput}
            onChange={(e) => onUploadImage?.(e.target.files?.[0])}
          />
          {uploadHint ? (
            <span className="mt-1.5 block text-[11px] text-neutral-500">{uploadHint}</span>
          ) : (
            <span className="mt-1.5 block text-[11px] text-neutral-500">
              Upload fills the URL below automatically.
            </span>
          )}
        </label>
        <label className={`${label} mt-4`}>
          Image URL
          <input
            className={`${input} mt-1.5 bg-white text-neutral-700`}
            value={article.image}
            readOnly
            placeholder="Upload a file above"
          />
        </label>
        {article.image ? (
          <button
            type="button"
            onClick={() => set('image', '')}
            className="mt-3 text-xs font-medium text-neutral-600 underline decoration-neutral-300 hover:text-neutral-900"
          >
            Clear image
          </button>
        ) : null}
        <label className={`${label} mt-4`}>
          Alt text
          <input className={input} value={article.alt} onChange={(e) => set('alt', e.target.value)} />
        </label>
      </div>

      <label className={`${label} sm:col-span-2`}>
        Read more link
        <input
          className={input}
          value={article.readMoreHref || '#contact'}
          onChange={(e) => set('readMoreHref', e.target.value)}
        />
      </label>
    </div>
  );
}
